import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/constants";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div dir="ltr" className="min-h-screen bg-ivory flex items-center justify-center px-5">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="w-full max-w-md bg-white rounded-3xl border border-sand p-8 md:p-10"
        data-testid="login-form"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <img src={LOGO} alt="L'Éclat du Regard" className="h-16 w-16 rounded-full object-cover ring-1 ring-gold/40" />
          <h1 className="mt-4 font-serif text-2xl text-ink">Espace administration</h1>
          <p className="text-sm text-taupe mt-1">L'Éclat du Regard</p>
        </div>

        {error && (
          <div className="mb-5 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700" data-testid="login-error">
            {error}
          </div>
        )}

        <label className="block text-sm text-taupe mb-1.5">Email</label>
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full mb-4 rounded-lg border border-sand bg-ivory px-4 py-3 text-ink outline-none focus:border-gold focus:ring-1 focus:ring-gold"
          data-testid="login-email"
        />
        <label className="block text-sm text-taupe mb-1.5">Mot de passe</label>
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full mb-6 rounded-lg border border-sand bg-ivory px-4 py-3 text-ink outline-none focus:border-gold focus:ring-1 focus:ring-gold"
          data-testid="login-password"
        />
        <button
          type="submit" disabled={loading}
          className="w-full rounded-full bg-gold py-3.5 text-white font-medium hover:brightness-105 transition-[filter] disabled:opacity-60"
          data-testid="login-submit"
        >
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </motion.form>
    </div>
  );
}
